import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useAddPartnerModal } from '../context/AddPartnerModalContext';

const AddPartnerModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useAddPartnerModal();

  const buttonDisabled =
    !data.name || !data.cif || !data.email || !data.isEmailValid;

  return (
    <>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSavePartner}
          disabled={buttonDisabled}
        >
          {t('AddPartner')}
        </button>
      </Modal.Footer>
    </>
  );
};

export default AddPartnerModalFooter;
